import i18n from 'i18next';
// import Backend from 'i18next-xhr-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  // .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: {
      es: {
        translation: {
          // todo: como é requerido em espanhol?? faltou algo em espanhol?
          'Inscrição': 'Inscripción',
          "CADASTRO DA EMPRESA": "CATASTRO DE LA EMPRESA",
          "INFORMAÇÕES DA EMPRESA": "INFORMACIÓN DE LA EMPRESA",
          "NOME COMERCIAL": "NOMBRE COMERCIAL",
          'NOME DA EMPRESA NO CRACHÁ': 'NOMBRE DE LA EMPRESA EN LA CREDENCIAL',
          'RAZÃO SOCIAL': 'RAZÓN SOCIAL',
          'ENDEREÇO COMPLETO': 'DIRECCIÓN COMPLETA',
          'Município': 'CIUDAD',
          'BREVE DESCRIÇÃO DA EMPRESA (RESUMO DE ATUAÇÃO DE SUA EMPRESA)': 'RESUMEN DESCRIPTIVO DE LA EMPRESA (AFEA DE ACTUACIÓN)',
          'CONTATOS': 'CONTACTOS',
          'TELEFONE COMERCIAL': 'TELÉFONO COMERCIAL',
          'CELULAR': 'CELULAR',
          'EMAIL': 'CORREO ELECTRÓNICO',
          'FACEBOOK': 'FACEBOOKKED',
          'INSTAGRAM': 'INSTRAGRAM',
          'LINKEDIN': 'LINKED IN',
          'YOUTUBE': 'YOU TUBE',
          'SITE': 'PAGINA DE INTERNET',
          'TWITTER': 'TWITTER',
          'PARTICIPANTE': 'PARTICIPANTE',
          'INFORMAÇÕES DO PARTICIPANTE': 'INFORMACIONES DEL PARTICIPANTE',
          'NOME COMPLETO': 'NOMBRE COMPLETO',
          'NOME NO CRACHÁ': 'NOMBRE EN LA CREDENCIAL',
          'SEXO': 'SEXO',
          'FEMININO': 'FEMENINO',
          'MASCULINO': 'MASCULINO',
          'OUTRO': 'OTRO',
          'CONTATO TELEFÔNICO': 'CONTACTO TELEFÓNICO',
          'PRODUTOS/SERVIÇOS': 'PRODUCTOS/SERVICIOS',
          'Produtos/Serviços que eu compro': 'PRODUCTOS/SERVICIOS QUE YO COMPRO',
          'Selecionar Produtos/Serviços': 'SELECIONAR PRODUCTOS/SERVICIOS',
          'Deletar Todos os Produtos': 'Eliminar todos los productos',
          'Deseja prosseguir?': 'Quieres proceder?',
          'Ao confirmar, todos os produtos dessa rodada serão removidos': 'Tras la confirmación, se eliminarán todos los productos de esa ronda.',
          'Produtos/Serviços que eu vendo': 'PRODUCTOS/SERVICIOS QUE YO VENDO',
          'Sugerir Outros Produtos/Serviços': 'SUGERIR OTROS PRODUCTOS/SERVICIOS',
          "Outros Produtos": "Otros productos",
          'Nova Sugestão': "Nueva sugerencia",
          "Nenhuma Sugestão Adicionada": "No se agregaron sugerencias",
          'TERMO DE CONSENTIMENTO (LGPD – LEI GERAL DE PROTEÇÃO DE DADOS)': 'TERMINO DE AUTORIZACIÓN - LEY GENERAL DE PROTECCIÓN DE DATOS',
          'Declaro que li e aceito os termos e condições.': 'DECLARO QUE HE LEIDO Y ACEPTO LOS TERMINOS Y CONDICIONES.',
          'INFORMO QUE OS SEUS DADOS PESSOAIS SERÃO UTILIZADOS PARA O CUMPRIMENTO DE OBRIGAÇÕES CONTRATUAIS, LEGAIS E REGULATÓRIAS DO SEBRAE EM RAZÃO DE SUAS ATIVIDADES, PARA A EXECUÇÃO DE SEUS PROGRAMAS E PRESTAÇÃO DE SERVIÇOS, PARA FOMENTAR, DESENVOLVER E MELHORAR SOLUÇÕES PARA EMPREENDEDORES E PEQUENOS NEGÓCIOS, PARA OFERECER PRODUTOS E SERVIÇOS QUE SEJAM DO SEU INTERESSE, PARA REALIZAR PESQUISAS COM OS CLIENTES QUE FORAM ATENDIDOS PELO SEBRAE E PARA REALIZAR A COMUNICAÇÃO OFICIAL PELO SEBRAE OU POR SEUS PRESTADORES DE SERVIÇO, POR TELEFONE, E-MAIL, SMS, WHATSAPP, ETC., BEM COMO AUTORIZO O COMPARTILHAMENTO DOS MEUS DADOS COM ENTIDADES PARCEIRAS DO SEBRAE E COM CONSULTORES CREDENCIADOS PARA AS MESMAS FINALIDADE ANTERIORMENTE ESPECIFICADAS. CASO VOCÊ QUEIRA CONHECER UM POUCO MAIS DE COMO O SEBRAE TRATA OS SEUS DADOS PESSOAIS, VOCÊ PODE ACESSAR O SEU PORTAL EM WWW.SEBRAE.COM.BR/LGPD, LÁ REUNIMOS UM CONJUNTO DE INFORMAÇÕES SOBRE COMO ESTAMOS ATUANDO COM OS DADOS PESSOAIS DE NOSSOS CLIENTES, COM FOCO EM SEGURANÇA E TRANSPARÊNCIA. POLÍTICA DE PRIVACIDADE: HTTPS://MINIO-CPE.SEBRAE.COM.BR/DOCUMENTO/POLITICA-PRIVACIDADE.PDF. AO ASSINAR O ': 'INFORMO QUE SUS DATOS PERSONALES SERÁN USADOS PARA EL CUMPLIMENTO DE OBLIGACIONES CONTRACTUALES, LEGALES Y REGULATORIAS DEL SEBRAE EN RAZÓN DE SUS ACTIVIDADES, PARA LA EJECUCÓN DE SUS PROGRAMAS Y PRESTACIÓN DE SERVICIOS, PARA EL FOMENTO DESARROLLO Y MEJORA DE SOLUCIONES PARA EMPRENDEDORES Y PEQUEÑOS NEGOCIOS, PARA OFRECER PRODUCTOS Y SERVICIOS QUE SEAN DE SU INTERÉS, PARA REALIZAR PESQUISAS CON LOS CLIENTES QUE FUERON ATENDIDOS POR EL SEBRAE Y PARA REALIZAR LA COMUNICACIÓN OFICIAL POR EL SEBRAE O POR SUS PRESTADORES DE SERVICIOS , POR TELÉFONO, CORREO ELECTRÓNICO, SMS, WHATSAPP, ETC... ASI COMO AUTORIZO EL COMPARTIR DE MIS DATOS CON ENTIDADES ASOCIADAS DEL SEBRAE Y CON CONSULTORES CREDENCIADOS PARA LAS MISMAS FINALIDADES ANTERIORMENTE ESPECIFICADAS. CASO USTED QUIERA CONOCER UN POCO MÁS DE COMO EL SEBRAE UTILIZA SUS DATOS PERSONALES, PUEDE ACCEDER A SU PÁGINA WWW.SEBRAE.COM.BR/LGPD DONDE REUNIMOS UN GRUPO DE INFORMACIONES SOBRE COMO ESTAMOS ACTUANDO CON LOS DATOS PERSONALES DE NUESTROS CLIENTES, CON OBJETIVO DE SEGURIDAD Y TRANSPARENCIA. POLITICA DE PRIVADIDAD: HTTPS://MINIO-CPE.SEBRAE.COM.BR/DOCUMENTO/POLITICA-PRIVACIDADE.PDF .  AL FIRMAR LA',
          "ACEITE LGPD,": 'ACEPTACION , LGPD,',
          ' MANIFESTO-ME DE FORMA INFORMADA, LIVRE, EXPRESSA E CONSCIENTE NO SENTIDO DE AUTORIZAR O SISTEMA SEBRAE A REALIZAR O TRATAMENTO DE MEUS DADOS PESSOAIS PARA AS FINALIDADES AQUI ESTABELECIDAS.': " EXPRESO DE LA MANERA INFORMADA,  LIBRE, EXPRESA Y CONCIENTEMENTE EN EL SENTIDO DE AUTORIZAR EL SISTEMA SEBRAE A LLEVAR A CABO EL TRATAMIENTO DE MIS DATOS PERSONALES, PARA LAS FINALIDADES AQUI INDICADAS.",
          'DECLARO QUE LI E ACEITO OS TERMOS E CONDIÇÕES.': 'DECLARO QUE HE LEIDO Y ACEPTO LOS TERMINOS Y CONDICIONES.',
          'Aceite LGPD. Acesse e leia a': 'Aceptar LGPD. Acceda y lea la',
          'Política Sebrae LGPD': 'Política LGPD del Sebrae',
          'NENHUM PRODUTO': 'SIN PRODUCTO',
          'GRUPO': 'GRUPO',
          'DESCRIÇÃO': 'DESCRIPCIÓN',
          'Inscrever-se': 'Inscribirse',
          'Esta rodada não pode receber inscrições': 'Esta ronda no puede recibir entradas',
          'Inscrição realizada com sucesso!': '¡Registro exitoso!',
          // 'Requerido': 'Requerido',
          'LINKS PÚBLICOS': 'ENLACES PÚBLICOS',
          'Retornar ao painel de controle': 'Volver al panel de control',
          "INSCRIÇÃO PÚBLICA ÂNCORA": "ANCLA REGISTRO PÚBLICO",
          "IR PARA O LINK": "IR AL ENLACE",
          "COPIAR": "COPIAR",
          "Link Copiado": "Enlace copiado",
          "INSCRIÇÃO PÚBLICA FORNECEDOR": "REGISTRO PÚBLICO DE PROVEEDORES",
          'DADOS DA RODADA': 'DATOS DE LA RODADA',
          'STATUS': 'ESTADO',
          'INSCRITO': 'REGISTRADO',
          'CANCELADO': 'CANCELADO',
          "PENDENTE/INSCRICAO": 'PENDIENTE/INSCRIPCIÓN',
          'Inscrição ok (padrão)': 'Inscripción ok (por defecto)',
          'Não vai participar da rodada': 'no participará en la rodada',
          'Falta alguma informação para aprovar a inscrição': 'Falta alguna información para aprobar la solicitud',
          "PRESENTE": "PRESENTE",
          'SAIU': 'SALIO',
          'AUSENTE': 'AUSENTE',
          'Vai participar (padrão)': 'Se unirá (predeterminado)',
          "Está presente": 'Está presente',
          'Estava presente, mas foi embora': 'Estaba allí pero se fue',
          'Participante não apareceu': 'El participante no se presentó',
          "Toda a agenda do participante será cancelada": "Se cancelará todo el horario del participante",
          'Toda a agenda é liberada em casos de participantes com Status Evento SAIU e AUSENTE, bem como em casos de status CANCELADO.': 'Se libera toda la agenda en los casos de participantes con Estado de Evento SALIO y AUSENTE, así como en casos de estado CANCELADO.',
          'OK': 'DE ACUERDO',
          'MESA': 'MESA',
          'TIPO DE INSCRIÇÃO': 'TIPO DE REGISTRO',
          "ÂNCORA": 'ANCLA',
          "FORNECEDOR": 'PROVEEDOR',
          "STATUS EVENTO": "ESTADO EN EL EVENTO",
          "NOME DA EMPRESA": "NOMBRE DE LA EMPRESA",
          "Salvar": "Ahorrar",
          "Novo": "Nuevo",
          "Sair": "Salir",
        }
      },
      pt: {
        translation: {
          "CADASTRO DA EMPRESA": "CADASTRO DA EMPRESA",
          "INFORMAÇÕES DA EMPRESA": "INFORMAÇÕES DA EMPRESA",
          "OUTRO": "OUTRO",
        }
      }
    },
    fallbackLng: 'pt',
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
